import WrappedText from '../wrappedText';
import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from 'copyright-clearance-center-common-ui';
import { observer } from 'mobx-react';
import React from 'react';

export interface IDeleteTagListItemProps {
	name: string;
	headerMessage?: string;
	textMessage?: string;
	onCancel: () => void;
	onDone: () => void;
}

const useStyles = makeStyles(() =>
	createStyles({
		buttonsContainer: {
			display: 'flex',
			alignSelf: 'center',
			gap: '0.5rem',
			margin: '0.13rem 0 0 0.5rem'
		},
		warningHeader: {
			color: Colors.error500,
			fontSize: '0.75rem',
			fontWeight: 500
		},
		warningHelperText: {
			color: Colors.error500,
			fontSize: '0.75rem',
			fontWeight: 400
		}
	})
);

export const DeleteTagListItem: React.FunctionComponent<IDeleteTagListItemProps> = ({
	name,
	headerMessage,
	textMessage,
	onCancel,
	onDone
}) => {
	const classes = useStyles();
	const header = headerMessage ?? localize('Are you sure you want to delete [{0}]?', name);
	const message = textMessage ?? localize('Deleting it will remove it from all your assets and folders.');

	return (
		<>
			<div style={{ overflow: 'hidden' }}>
				<WrappedText className={classes.warningHeader} text={header} testId="delete-tag-header" />
				<div className={classes.warningHelperText} data-test-id="delete-tag-info">
					{message}
				</div>
			</div>
			<div className={classes.buttonsContainer}>
				<button
					type="button"
					className="rup-btn rup-btn rup-btn--text"
					data-test-id="delete-tag-cancel-btn"
					key="cancel"
					onClick={onCancel}
				>
					{localize('Cancel')}
				</button>
				<button
					type="button"
					className="rup-btn rup-btn--error"
					data-test-id="delete-tag-delete-btn"
					key="delete"
					onClick={onDone}
				>
					{localize('Delete')}
				</button>
			</div>
		</>
	);
};

export default observer(DeleteTagListItem);
